/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.m-hero {
  background-color: var(--gray-5);
}
.m-hero__wrapper {
  display: grid;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
}
.m-hero__text {
  padding-right: 15px;
  padding-left: 15px;
}
.m-hero__heading {
  font-size: 2.125em;
  font-weight: 600;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
  margin-bottom: 0.4411764706em;
}
p + .m-hero__heading, ul + .m-hero__heading, ol + .m-hero__heading, dl + .m-hero__heading, figure + .m-hero__heading, img + .m-hero__heading, table + .m-hero__heading, blockquote + .m-hero__heading {
  margin-top: 1.7647058824em;
}
.m-hero__subhead {
  font-size: 22px;
  line-height: 1.25;
}
.m-hero__image-wrapper {
  box-sizing: border-box;
  overflow: hidden;
}
.m-hero__image {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  display: none;
}
@supports (display: grid) {
  .m-hero__image {
    display: block;
  }
}
.m-hero--knockout {
  background-color: var(--gray);
  color: var(--white);
}
.m-hero--overlay .m-hero__wrapper {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.m-hero--jumbo, .m-hero--50-50 {
  background-color: var(--white);
}
.m-hero--jumbo .m-hero__subhead, .m-hero--50-50 .m-hero__subhead {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
@media only all and (max-width: 37.5em) {
  .m-hero--jumbo .m-hero__subhead, .m-hero--50-50 .m-hero__subhead {
    font-size: 1.125em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
}
@media only all and (min-width: 37.5625em) {
  .m-hero--jumbo .m-hero__subhead, .m-hero--50-50 .m-hero__subhead {
    font-size: 1.375em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.6818181818em;
  }
  p + .m-hero--jumbo .m-hero__subhead, ul + .m-hero--jumbo .m-hero__subhead, ol + .m-hero--jumbo .m-hero__subhead, dl + .m-hero--jumbo .m-hero__subhead, figure + .m-hero--jumbo .m-hero__subhead, img + .m-hero--jumbo .m-hero__subhead, table + .m-hero--jumbo .m-hero__subhead, blockquote + .m-hero--jumbo .m-hero__subhead, h1 + .m-hero--jumbo .m-hero__subhead, .h1 + .m-hero--jumbo .m-hero__subhead, h2 + .m-hero--jumbo .m-hero__subhead, .h2 + .m-hero--jumbo .m-hero__subhead, h4 + .m-hero--jumbo .m-hero__subhead, .h4 + .m-hero--jumbo .m-hero__subhead, h5 + .m-hero--jumbo .m-hero__subhead, .h5 + .m-hero--jumbo .m-hero__subhead, h6 + .m-hero--jumbo .m-hero__subhead, .h6 + .m-hero--jumbo .m-hero__subhead, p + .m-hero--50-50 .m-hero__subhead, ul + .m-hero--50-50 .m-hero__subhead, ol + .m-hero--50-50 .m-hero__subhead, dl + .m-hero--50-50 .m-hero__subhead, figure + .m-hero--50-50 .m-hero__subhead, img + .m-hero--50-50 .m-hero__subhead, table + .m-hero--50-50 .m-hero__subhead, blockquote + .m-hero--50-50 .m-hero__subhead, h1 + .m-hero--50-50 .m-hero__subhead, .h1 + .m-hero--50-50 .m-hero__subhead, h2 + .m-hero--50-50 .m-hero__subhead, .h2 + .m-hero--50-50 .m-hero__subhead, h4 + .m-hero--50-50 .m-hero__subhead, .h4 + .m-hero--50-50 .m-hero__subhead, h5 + .m-hero--50-50 .m-hero__subhead, .h5 + .m-hero--50-50 .m-hero__subhead, h6 + .m-hero--50-50 .m-hero__subhead, .h6 + .m-hero--50-50 .m-hero__subhead {
    margin-top: 1.3636363636em;
  }
}
@media only all and (min-width: 63.8125em) {
  .m-hero--jumbo .m-hero__wrapper, .m-hero--50-50 .m-hero__wrapper {
    min-height: 285px;
  }
  .m-hero--jumbo .m-hero__heading, .m-hero--50-50 .m-hero__heading {
    margin-bottom: 0.4166666667em;
    font-size: 3em;
    font-weight: normal;
    line-height: 1.25;
  }
  .m-hero--jumbo .m-hero__subhead, .m-hero--50-50 .m-hero__subhead {
    font-size: 1.625em;
    font-weight: 400;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.5769230769em;
  }
  p + .m-hero--jumbo .m-hero__subhead, ul + .m-hero--jumbo .m-hero__subhead, ol + .m-hero--jumbo .m-hero__subhead, dl + .m-hero--jumbo .m-hero__subhead, figure + .m-hero--jumbo .m-hero__subhead, img + .m-hero--jumbo .m-hero__subhead, table + .m-hero--jumbo .m-hero__subhead, blockquote + .m-hero--jumbo .m-hero__subhead, p + .m-hero--50-50 .m-hero__subhead, ul + .m-hero--50-50 .m-hero__subhead, ol + .m-hero--50-50 .m-hero__subhead, dl + .m-hero--50-50 .m-hero__subhead, figure + .m-hero--50-50 .m-hero__subhead, img + .m-hero--50-50 .m-hero__subhead, table + .m-hero--50-50 .m-hero__subhead, blockquote + .m-hero--50-50 .m-hero__subhead {
    margin-top: 1.7307692308em;
  }
  h1 + .m-hero--jumbo .m-hero__subhead, .h1 + .m-hero--jumbo .m-hero__subhead, h3 + .m-hero--jumbo .m-hero__subhead, .h3 + .m-hero--jumbo .m-hero__subhead, h4 + .m-hero--jumbo .m-hero__subhead, .h4 + .m-hero--jumbo .m-hero__subhead, h5 + .m-hero--jumbo .m-hero__subhead, .h5 + .m-hero--jumbo .m-hero__subhead, h6 + .m-hero--jumbo .m-hero__subhead, .h6 + .m-hero--jumbo .m-hero__subhead, h1 + .m-hero--50-50 .m-hero__subhead, .h1 + .m-hero--50-50 .m-hero__subhead, h3 + .m-hero--50-50 .m-hero__subhead, .h3 + .m-hero--50-50 .m-hero__subhead, h4 + .m-hero--50-50 .m-hero__subhead, .h4 + .m-hero--50-50 .m-hero__subhead, h5 + .m-hero--50-50 .m-hero__subhead, .h5 + .m-hero--50-50 .m-hero__subhead, h6 + .m-hero--50-50 .m-hero__subhead, .h6 + .m-hero--50-50 .m-hero__subhead {
    margin-top: 1.1538461538em;
  }
}

@media only all and (max-width: 37.5em) {
  .m-hero__image-wrapper {
    margin-top: 1.875em;
  }
  .m-hero--overlay .m-hero__wrapper {
    background-image: none !important;
  }
  .m-hero--jumbo .m-hero__wrapper {
    padding-bottom: 0;
  }
}
@media only all and (max-width: 56.25em) {
  .m-hero__heading {
    font-size: 1.625em;
    font-weight: 600;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
    margin-bottom: 0.5769230769em;
  }
  p + .m-hero__heading, ul + .m-hero__heading, ol + .m-hero__heading, dl + .m-hero__heading, figure + .m-hero__heading, img + .m-hero__heading, table + .m-hero__heading, blockquote + .m-hero__heading {
    margin-top: 1.7307692308em;
  }
  h1 + .m-hero__heading, .h1 + .m-hero__heading, h3 + .m-hero__heading, .h3 + .m-hero__heading, h4 + .m-hero__heading, .h4 + .m-hero__heading, h5 + .m-hero__heading, .h5 + .m-hero__heading, h6 + .m-hero__heading, .h6 + .m-hero__heading {
    margin-top: 1.1538461538em;
  }
  .m-hero__subhead {
    font-size: 18px;
  }
}
@media only all and (min-width: 37.5625em) {
  .m-hero__wrapper {
    grid-template-columns: 7fr 5fr;
    padding-right: 15px;
    padding-left: 15px;
    min-height: 225px;
  }
  .m-hero__text {
    margin: auto;
  }
  .m-hero__image-wrapper {
    padding-right: 15px;
    padding-left: 15px;
    display: flex;
    align-items: center;
  }
  .m-hero--bleeding .m-hero__image-wrapper {
    width: 100%;
    margin-top: -2.8125em;
    margin-bottom: -2.8125em;
  }
  .m-hero--bleeding .m-hero__image {
    padding-bottom: 0 !important;
    height: 100%;
    width: 100%;
    background-size: cover;
  }
  .m-hero--overlay .m-hero__image {
    display: none;
  }
  .m-hero--jumbo .m-hero__wrapper {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .m-hero--jumbo .m-hero__image {
    display: none;
  }
  .m-hero--50-50 .m-hero__wrapper {
    grid-template-columns: 1fr 1fr;
    border: 1px solid var(--gray-40);
    border-top: none;
    background-position: 100% center;
    background-repeat: no-repeat;
    background-size: 50%;
  }
  .m-hero--50-50 .m-hero__image {
    display: none;
  }
}
@media only all and (min-width: 63.8125em) {
  .m-hero__wrapper {
    padding-top: 2.8125em;
    padding-bottom: 2.8125em;
    min-height: 195px;
  }
  .m-hero--bleeding .m-hero__image-wrapper {
    margin-top: -2.8125em;
    margin-bottom: -2.8125em;
  }
  .m-hero--50-50 .m-hero__wrapper {
    min-height: 345px;
  }
}